import { useQuery } from '@tanstack/react-query';
import req from 'utils/req';
import { z } from 'zod';

const countrySchema = z.object({
  name: z.string(),
  callingCode: z.string(),
  altSpellings: z.array(z.string()),
  nativeNames: z.array(z.string()),
  countryCode: z.string(),
  flag: z.string().url(),
});
export type Country = z.infer<typeof countrySchema>;

export async function fetchCountries() {
  try {
    const response = await req(`${URL_API_HOST}/api/v1/countries`).get();
    const result = z.array(countrySchema).safeParse(response);

    if (!result.success) {
      console.error('failed to parse countries, still returning...');
      return response as Country[];
    }

    return result.data;
  } catch (error: any) {
    console.log('failed to fetch countries', error);
    return [];
  }
}

export const useCountries = () => {
  const query = useQuery({
    queryKey: ['countries'],
    queryFn: () => fetchCountries(),
    staleTime: 1000 * 60 * 60 * 24,
    placeholderData: [],
  });

  return query;
};
